// src/App.jsx
import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Toaster } from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import AppRouter from '@/routes/AppRouter'
import ErrorBoundary from '@/components/common/ErrorBoundary'
import useAuthStore from '@/store/authStore'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000, // 30 seconds
    },
  },
})

export default function App() {
  const { t } = useTranslation()
  const token       = useAuthStore((state) => state.token)
  const initialized = useAuthStore((state) => state.initialized)
  const fetchMe     = useAuthStore((state) => state.fetchMe)

  useEffect(() => {
    if (token && !initialized) {
      fetchMe()
    }
  }, [token, initialized, fetchMe])

  if (token && !initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="mx-auto mb-3 h-10 w-10 rounded-full border-4 border-slate-200 border-t-[#0d2757] animate-spin" />
          <p className="text-sm text-slate-500">{t('common.restoringSession')}</p>
        </div>
      </div>
    )
  }

  return (
    <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <AppRouter />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            borderRadius: '10px',
            background: '#0d2757',
            color: '#fff',
            fontSize: '14px',
          },
          success: { style: { background: '#166534', color: '#fff' } },
          error:   { style: { background: '#991b1b', color: '#fff' } },
        }}
      />
    </QueryClientProvider>
    </ErrorBoundary>
  )
}
